import { Button } from "@progress/kendo-react-buttons";

import { useTranslation } from "react-i18next";

interface GxBlackButtonProp {
  onClick: () => void;
  label?: string;
  className?: string;
}

const GxcommonBtn = ({ onClick, label = "", className }: GxBlackButtonProp) => {
  const { t } = useTranslation();
  return (
    <Button
      onClick={onClick}
      className={`gx-common-btn ${className ? className : ""}`}
    >
      {t(label) || ""}
    </Button>
  );
};

export default GxcommonBtn;
